import styled from 'styled-components';
const ListItem = styled.div.withConfig({ displayName: "brc-ListItem", componentId: "brc-1oawt85" }) `
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex: 1 1 100%;
  padding-bottom: 24px;
`;
ListItem.displayName = 'ListItem';
export default ListItem;
//# sourceMappingURL=list-item.js.map